var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6641,
    cy: 32.3672,
    r: 32,
    fill: "#E6F4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8766 25.4039H39.6817C38.0832 25.4039 36.7812 24.102 36.7812 22.5035V17.3086C37.0906 17.4375 37.3871 17.6438 37.632 17.8887L44.2965 24.5532C44.5414 24.7981 44.7348 25.0946 44.8766 25.4039Z",
    fill: "#2995DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6781 27.3368C37.0136 27.3368 34.8441 25.1686 34.8441 22.5028V17.0371H23.093C21.4842 17.0371 20.1797 18.3416 20.1797 19.9504V44.7869C20.1797 46.3931 21.4816 47.6963 23.0878 47.6963H42.2344C43.8418 47.6963 45.1438 46.3931 45.1438 44.7869V27.3368H39.6781ZM26.3724 29.8956H31.3817C32.0224 29.8956 32.5419 30.4151 32.5419 31.0557C32.5419 31.6964 32.0224 32.2159 31.3817 32.2159H26.3724C25.7317 32.2159 25.2122 31.6964 25.2122 31.0557C25.2122 30.4151 25.7304 29.8956 26.3724 29.8956ZM36.3098 43.2065H26.3724C25.7317 43.2065 25.2122 42.687 25.2122 42.0463C25.2122 41.4057 25.7317 40.8862 26.3724 40.8862H36.3098C36.9505 40.8862 37.47 41.4057 37.47 42.0463C37.47 42.687 36.9505 43.2065 36.3098 43.2065ZM38.9524 37.7112H26.3711C25.7304 37.7112 25.2109 37.1917 25.2109 36.551C25.2109 35.9104 25.7304 35.3909 26.3711 35.3909H38.9524C39.5931 35.3909 40.1126 35.9104 40.1126 36.551C40.1126 37.1917 39.5931 37.7112 38.9524 37.7112Z",
    fill: "#2995DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/Draft.380fee5f424bdd52b2546bbbe9252bd2.svg";
export { ForwardRef as ReactComponent };